import produce from 'immer';
import { AnyAction } from 'redux';
import {
  CONNECT_WALLET_ERROR,
  CONNECT_WALLET_LOADING,
  CONNECT_WALLET_SUCCESS
} from '../ActionTypes';
import { IWallet } from 'interfaces';

type InitialStateType = {
  loading: boolean;
  loaded: boolean;
  error: string;
  data?: IWallet;
};

export const INIT_STATE: InitialStateType = {
  loading: false,
  loaded: false,
  error: '',
  data: JSON.parse(`${localStorage.getItem('wallet')}`)
};

export const WalletReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case CONNECT_WALLET_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        draft.data = action.payload.data;
        break;
      case CONNECT_WALLET_LOADING:
        draft.error = '';
        draft.loading = true;
        draft.loaded = false;
        break;
      case CONNECT_WALLET_ERROR:
        draft.loading = false;
        draft.loaded = false;
        draft.error = action.payload;
        break;
    }
  });
